/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Error_TitleInputs */

const en_loading_error_title = /** @type {(inputs: Loading_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The data could not be loaded`)
};

const id_loading_error_title = /** @type {(inputs: Loading_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data belum berhasil dimuat`)
};

/**
* | output |
* | --- |
* | "The data could not be loaded" |
*
* @param {Loading_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_error_title = /** @type {((inputs?: Loading_Error_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Error_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_error_title(inputs)
	return en_loading_error_title(inputs)
});